import { startCase } from 'lodash';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { UserMfaDevice } from '@lib/api/entities';
import { SnUsersAPI } from '@lib/api/services';
import { SnFormFieldConfig } from '@lib/form';
import { t } from '@lib/translation';

@Component({
  templateUrl: './manage-mfa-dialog.component.html',
  styleUrls: ['./manage-mfa-dialog.component.scss'],
})
export class ManageMfaDialogComponent implements OnInit, OnDestroy {
  public isLoading: boolean = false;
  public qrCodeUrl: string;
  public deactivateForm = new UntypedFormGroup({});
  public activateForm = new UntypedFormGroup({});
  public formModel: any = {};
  public formFields: SnFormFieldConfig[] = [];

  private readonly _destroy$ = new Subject<void>();

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      user: any;
      mfa: UserMfaDevice;
      action: string;
    },
    private readonly _usersAPI: SnUsersAPI,
    private readonly _dialogRef: MatDialogRef<ManageMfaDialogComponent>,
    private readonly _cd: ChangeDetectorRef,
  ) {}

  public ngOnInit(): void {
    this.qrCodeUrl = this.data.mfa.configUrl;
    this._createFormFields();
  }

  private _createFormFields(): void {
    this.formFields = [
      {
        key: 'totpToken',
        type: 'input',
        name: 'uid',
        templateOptions: {
          appearance: 'outline',
          required: true,
          type: 'tel',
          label: t('account.dialogs.mfa.setup.verificationStep.verificationToken'),
          placeholder: t('account.dialogs.mfa.setup.verificationStep.verificationTokenPlaceholder'),
        },
      },
    ];
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public isArray(value: any): boolean {
    return Array.isArray(value);
  }

  public toStartCase(text: string): string {
    return startCase(text);
  }

  public submitForm(): void {
    if (this.data.action === 'activate') {
      if (this.activateForm.invalid) {
        return;
      }
      this.isLoading = true;
      this._usersAPI
        .activateMfa(this.data.user.id, this.data.mfa.id, {
          totpToken: this.formModel.totpToken,
        })
        .pipe(takeUntil(this._destroy$))
        .subscribe({
          next: () => {
            this.isLoading = false;
            this.data.mfa.confirmed = true;
            this._dialogRef.close(this.data.mfa);
          },
          error: (err) => {
            this.isLoading = false;
            this.activateForm.setErrors(err.error);
          },
        });
    } else {
      if (this.deactivateForm.invalid) {
        return;
      }
      this.isLoading = true;
      this._usersAPI
        .deactivateMfa(this.data.user.id, this.data.mfa.id, {
          totpToken: this.formModel.totpToken,
        })
        .pipe(takeUntil(this._destroy$))
        .subscribe({
          next: () => {
            this.isLoading = false;
            this._dialogRef.close(this.data.mfa);
          },
          error: (err) => {
            this.isLoading = false;
            this.deactivateForm.setErrors(err.error);
            this._cd.detectChanges();
          },
        });
    }
  }
}
